import { render, staticRenderFns } from "./ThePressKitLayout.vue?vue&type=template&id=4cb1ee82&scoped=true"
import script from "./ThePressKitLayout.vue?vue&type=script&lang=js"
export * from "./ThePressKitLayout.vue?vue&type=script&lang=js"
import style0 from "./ThePressKitLayout.vue?vue&type=style&index=0&id=4cb1ee82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb1ee82",
  null
  
)

export default component.exports